






































let loadService!: any;
let vm!: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import loadJS, { loadCss } from '../../utils/loadJs';
import { TimelineItemViewModel, TimelineItemService } from '../../api/timelineItem';
import FileService from '../../api/file';
import { DynastyViewModel, DynastyService } from '../../api/dynasty';
import FilePreview from '../File/Preview.vue';
@Component({
  components: {
    FilePreview,
  },
})
export default class TimelineIndex extends Vue {
  private service: TimelineItemService = new TimelineItemService();
  private data!: any;
  private condition: TimelineItemViewModel = this.service.NewModel;
  private fileService: FileService = new FileService();

  private dynastyService: DynastyService = new DynastyService();
  private dynastyData: any[] = [];
  private dynastyIndex: number = 0;

  private showPreview: boolean = false;
  private currentFile: any = this.fileService.NewModel;



  private tl: any;
  private tlHeight: string = '500px';
  private timelineJson = {
    // title: {
    //   text: {
    //       headline: 'Nr Processo: 007969031',
    //       text: 'dddd',
    //   },
    // },
    events: [
      {
        start_date: {
            year: '1900',
        },
        media: {
          url: '<iframe src="Timeline/detail" width="500" height="600"></iframe>',
        },
      },
    ],
  };
  private timelineOptions = {
    width: '100%',
    height: '100%',
    timenav_position: 'bottom',
    script_path: '/static',
    language: 'zh-cn',
    start_at_end: false,
    initial_zoom: 2,
    timenav_height_percentage: 30,
    duration: 0,
  };
  private created() {
    loadCss('../../static/TimelineJS3/css/timeline.css');
    loadJS('../../static/TimelineJS3/js/timeline-min.js').then(() => {
      this.loadData();
    });
  }
  private loadData() {
    loadService = this.$loading({});
    this.condition.isPublic = 1;
    this.service.GetTimelineData(this.condition).then((response: any) => {
      this.data = response;
      this.tl = new (window as any).TL.Timeline('timeline-container', this.data, this.timelineOptions);
      console.log(this.tl);
      this.tl.on('dataloaded', () => {
        // vm.$nextTick(() => {
        //   loadService.close();
        // });
      });
      vm.$nextTick(() => {
          loadService.close();
        });
    });
  }
  private loadDynasty() {
    this.dynastyService.GetAll().then((response: any) => {
      this.dynastyData = response;
      this.dynastyData.splice(0, 0, { name: '全部朝代', id: 0});
    });
  }
  private dynasty_OnChange(val: number) {
    console.log(val);
    const item = this.dynastyData[val];
    this.condition.startYear = item.startYear;
    this.condition.endYear = item.endYear;
  }
  private btnSearch_OnClick() {
    this.loadData();
  }
  private mounted() {
    (window as any).vm = this;
    vm = this;
    this.tlHeight = (window.innerHeight - 210) + 'px';
    this.loadDynasty();
    // this.tl = new TL.Timeline('timeline-container', this.timelineJson, this.options);
  }
  private preview_OnClick(file: any) {
    this.currentFile = file;
    this.showPreview = true;
  }
}
